import { initializeGTM } from 'src/utils/google-tag-manager';

export {
  trackEvent,
  trackPageView,
  pushDataLayer,
  trackEventBeforeNavigation,
} from 'src/utils/google-tag-manager';

// Trigger GTM initialization. GA4 is wired in the GTM container per environment.
export function initAnalytics(): void {
  initializeGTM();
}
